module.exports = __webpack_public_path__ + "img/horizontal_6_1_6000.fdd89c02.png";